
export const WORKER_UPDATE = 'WORKER_UPDATE'
export const POP_FETCH_QUEUE = 'POP_FETCH_QUEUE'
export const REGISTER_WORKER = 'REGISTER_WORKER'
export const WORKER_CLAIM_TASK = 'WORKER_CLAIM_TASK'


// WEBPACK FOOTER //
// ./src/constants/worker-constants.js